import React from "react";
import { compose, withProps } from "recompose";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker
} from "react-google-maps";

import styles from "./index.module.css";
import "./override.css";
import mapStyles from "./style.json";

import { checkIsPC } from "../../atoms";
import useDims from "../useDims";

import icon from "../../../assets/disco/disco-marker.svg";

const MapContainer = props => {
  const { width } = useDims({ height: 0, width: window.innerWidth });
  const isPC = checkIsPC(width);

  const mobileHeight = (388 / 591) * width;

  return (
    <div
      className={styles.map}
      style={{
        width: isPC ? 591 : "auto",
        height: isPC ? 388 : mobileHeight
      }}
      {...props}
    ></div>
  );
};

const GoogleMaps = compose(
  withProps({
    googleMapURL:
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyDpeFHyasKnpXtLEc6hLMmUQ9-SFZVe3xk&v=3.exp&libraries=geometry,drawing,places",
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <MapContainer />,
    mapElement: <div style={{ height: `100%` }} />
  }),
  withScriptjs,
  withGoogleMap
)(props => (
  <GoogleMap
    defaultZoom={17}
    defaultCenter={{ lat: 35.646433, lng: 139.753008 }}
    options={{
      // ref: https://tomchentw.github.io/react-google-maps/#googlemap
      styles: mapStyles,
      disableDefaultUI: true,
      tilt: 0,
      zoomControl: true,
      maxZoom: 18,
      minZoom: 15,
      gestureHandling: "cooperative",
      controlSize: checkIsPC(window.innerWidth) ? 60 : 40
    }}
    {...props}
  >
    <Marker position={{ lat: 35.646156, lng: 139.753204 }} icon={icon} />
  </GoogleMap>
));

export default GoogleMaps;
